
$(document).ready(function() {
    let $contract_date,$contract_business_name,$contract_reference,$contract_signature,$contract_pay,$contract_hosting,$contract_domain,$contract_status;
    $(function () {
        $contract_date = $('#contract_date');
        $contract_business_name = $('#contract_business_name');
        $contract_reference = $('#contract_reference');
        $contract_signature = $('#contract_signature');
        $contract_pay = $('#contract_pay');
        $contract_hosting = $('#contract_hosting');
        $contract_domain = $('#contract_domain');
        $contract_status = $('#contract_status');

        $contract_signature.change(onChangeFilter);
        $contract_pay.change(onChangeFilter);
        $contract_hosting.change(onChangeFilter);
        $contract_domain.change(onChangeFilter);
        $contract_status.change(onChangeFilter);
    });
    $('#contract_date,#contract_business_name,#contract_reference').keypress(function (e) {
        if(e.which == 13) {
            onChangeFilter();
        }
    });
    function onChangeFilter(){
        let date = $contract_date.val();
        date = date.replace(' ','-')
        date = date.replace(' ','-')
        location.href = '/?date='+date+
            '&business_name='+$contract_business_name.val()+
            '&reference='+$contract_reference.val()+
            '&signature='+$contract_signature.val()+
            '&pay='+$contract_pay.val()+
            '&hosting='+$contract_hosting.val()+
            '&domain='+$contract_domain.val()+
            '&status='+$contract_status.val();
    }
} );